import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery, showNotification } from "@/services/api";
import { ListResponse } from "@/types/response.type";
import { Tenant, TenantForm } from "@/types/tenant.type";
import { IDropdown } from "@/constants/default";

export const tenantApi = createApi({
  reducerPath: "tenantApi",
  baseQuery,
  tagTypes:['tenants'],
  endpoints: (builder) => ({
    getTenants: builder.query<ListResponse<Tenant>, {}>({
      query: (data) => ({ url: `tenant`, params: data }),
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: ListResponse<Tenant> }, meta) => {
        return rawResult.data
      },
    }),
    getDropDownTenants: builder.query<IDropdown[], {}>({
      query: () => ({ url: `tenant/dropdown` }),
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: {data: IDropdown[]}, meta) => {
        return rawResult?.data || []
      },
    }),
    getTenant: builder.query<Tenant, string>({
      query: (id) => `tenant/${id}`,
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: Tenant }, meta) => {
        return rawResult.data
      },
    }),
    addTenant: builder.mutation<any, TenantForm>({
      query: (body) => ({
        url: 'tenant',
        method: 'POST',
        body,
      }),
      transformResponse: (rawResult: { data: Tenant }, meta) => {
        return rawResult.data
      },
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("POST", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("POST", "error", err?.error?.data?.message || "error")
        }
      }
    }),
    editTenant: builder.mutation<Tenant, Pick<Tenant, "id">>({
      query: ({ id, ...body }) => ({
        url: `tenant/${id}`,
        method: 'PUT',
        body,
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("PUT", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("PUT", "error", err?.error?.data?.message || "error")
        }
      }
    }),
    deleteTenant: builder.mutation<any, string>({
      query: (id) => ({
        url: `tenant/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("DELETE", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("DELETE", "error", err?.error?.data?.message || "error")
        }
      }
    }),
  }),
});

export const { useLazyGetDropDownTenantsQuery, useGetTenantsQuery, useGetTenantQuery, useAddTenantMutation, useEditTenantMutation, useDeleteTenantMutation } = tenantApi;
